export enum ToothStatus {
  empty = '',
  clicked = 'blue',
  approved = 'green',
  dotted = 'open',
  disabled = 'closed',
  linked = 'linked',
  highlighted = 'highlighted',
}
